import {IEdiOrder} from '../../interfaces/EDI-order.interface';
import {ITransactionRequest} from '../../interfaces/transaction-request.interface';
import { IFileUploadObject } from '../../components/file-uploader/file-upload-object.interface';
import { IUpdateOrderRequest } from 'src/app/inventory/interfaces/IUpdateOrderRequest';
import { IDestroyInventoryRequest } from 'src/app/inventory/interfaces/destroy-inventory-request.interface';
import { OrderPartyDetail, OrderPartyTypeEnum } from 'src/app/inventory/interfaces/order-party-details.interface';

export class GetUserOrders {
  static readonly type = '[Orders] get user orders';

  constructor() {
  }
}

export class GetOrderHistoryList {
  static readonly type = '[Orders] get all orders history';

  constructor(public searchString: string) {
  }
}

export class GetEDIOrder {
  static readonly type = '[Orders] get receive EDI';

  constructor(public id?: number) {
  }
}

export class GetEDIAttachment {
  static readonly type = '[Orders] get EDI attachment presigned download url';

  constructor(public attachment?: any) {
  }
}

export class GetEDIAttachments {
  static readonly type = '[Orders] get receive EDI attachments';

  constructor(public id?: number) {
  }
}

export class SaveEDIAttachments {
  static readonly type = '[Orders] save receive EDI attachments';

  constructor(public files: IFileUploadObject[], public payload: any) {
  }
}

export class GetInventoryOrderDetails {
  static readonly type = '[Orders] get details for selected inventory order';

  constructor(public id: number) {
  }
}

export class SetInventoryOrderDetails {
  static readonly type = '[Orders] set details for selected inventory order e.g. to sort the table';

  constructor(public orderDetails) {
  }
}

export class GetOrderDetailsAttachments {
  static readonly type = '[Orders] get current order attachments';

  constructor(public id: number) {
  }
}

export class SaveOrderDetailsAttachments {
  static readonly type = '[Orders] set current order attachments';

  constructor(public request: {attachments, pin}) {
  }
}

export class ReceiveOrderHistoryRecord {
  static readonly type = '[Orders] get not received order history record';

  constructor(public id: number) {
  }
}

export class ReceiveEDIOrder {
  static readonly type = '[Orders] send drugs to receive EDI';

  constructor(public receiveEDI: IEdiOrder) {
  }
}

export class AddEDIOrder {
  static readonly type = '[Orders] send drugs to add EDI';

  constructor(public transactions: ITransactionRequest[]) {
  }
}

export class DecrementProcessedOrdersCount {
  static readonly type = '[Orders] decrement processed orders count';

  constructor() {
  }
}

export class SetFileLoadingState {
  static readonly type = '[Orders] Set File Loading State';

  constructor(public id: string) {
  }
}

export class UpdateUploadedAttachment {
  static readonly type = '[Orders] update uploaded attachment';

  constructor(public id: string) {
  }
}

export class UpdateOrder {
  static readonly type = '[Orders] update order';

  constructor(public order: IUpdateOrderRequest) {
  }
}

export class CreateProvider {
  static readonly type = '[Orders] create provider';

  constructor(public name: string) {
  }
}

export class CreateReverseDistributor {
  static readonly type = '[Orders] Create Reverse Distributor';

  constructor(public name: string) {
  }
}

export class CreatePlaceOfDestruction {
  static readonly type = '[Orders] Create Place Of Destruction';

  constructor(public name: string) {
  }
}

export class GetProvidersList {
  static readonly type = '[Orders] get providers list';

  constructor() {
  }
}

export class GetReverseDistributorsList {
  static readonly type = '[Orders] Get Reverse Distributors List';

  constructor() {
  }
}

export class GetPlacesOfDestructionList {
  static readonly type = '[Orders] Get Places Of Destruction List';

  constructor() {
  }
}

export class SaveNewSaleOrReturn {
  static readonly type = '[Orders] Save New Sale To Provider';

  constructor(public payload) {
  }
}

export class DestroyInventory {
  static readonly type = '[Orders] Destroy Inventory';

  constructor(public payload: IDestroyInventoryRequest) {
  }
}
export class GetSalesToProviders {
  static readonly type = '[Orders] Get Sales To Providers';

  constructor() {
  }
}

export class GetSalesToReverseDistributors {
  static readonly type = '[Orders] Get Sales To Reverse Distributors';

  constructor() {
  }
}

export class GetReturnsToWholesalers {
  static readonly type = '[Orders] Get Get Returns To Wholesalers';

  constructor() {
  }
}

export class GetInventoryDestructions {
  static readonly type = '[Orders] Get Inventory Destructions';

  constructor() {
  }
}

export class GetSaleToProviderDetails {
  static readonly type = '[Orders] Get Sale To Provider Details';

  constructor(public id: string) {
  }
}

export class GetSaleToReverseDistributorDetails {
  static readonly type = '[Orders] Get Sale To Reverse Distributor Details';

  constructor(public id: string) {
  }
}

export class GetReturnToWholesalerDetails {
  static readonly type = '[Orders] Get Return ToWholesaler Details';

  constructor(public id: string) {
  }
}

export class GetInventoryDestructionDetails {
  static readonly type = '[Orders] Get Inventory Destruction Details';

  constructor(public id: string) {
  }
}

export class GetBuyersList {
  static readonly type = '[Orders] Get Buyers';

  constructor() {
  }
}

export class GetEdiSuppliersList {
  static readonly type = '[Orders] Get Edi Suppliers List';

  constructor() {
  }
}

export class SaveSupplierBuyer {
  static readonly type = '[Orders] Save Supplier Buyer';

  constructor(public detail: OrderPartyDetail) {
  }
}

export class GetSelectedPartyLatestDetailsByID {
  static readonly type = '[Orders] Get Selected Party Latest Detail';

  constructor(public id: string) {
  }
}

export class GetPartyLatestDetails {
  static readonly type = '[Orders] Get Party Latest Details';

  constructor(public type: OrderPartyTypeEnum) {
  }
}

export class SetPartyDetail {
  static readonly type = '[Orders] Set Party Detail';

  constructor(public detail: OrderPartyDetail) {
  }
}
export class ClearOrdersState {
  static readonly type = '[Orders] Clear State';

  constructor() {
  }
}

export class SetLoading {
  static readonly type = '[Orders] Set Loading';

  constructor(public isLoading: boolean) {
  }
} 